import { CountryCodeEnum } from 'common/data/country/code.enum';
import { configGetCountry } from 'common/helper/config/get-country';

export const myNotesGetIsAvailable = (): boolean => {
  return configGetCountry().code !== CountryCodeEnum.ae;
};
